import { manifest } from "@/docs/manifest";
import { isStagingEnvironment } from "@/firebase";
import { Box } from "@mantine/core";

export type DocPath = keyof typeof manifest;

export const Doc = ({ path }: { path: DocPath }) => {
  const Doc = manifest[path];

  if (!Doc) {
    return <div>Doc not found.</div>;
  }

  return (
    <>
      {(isStagingEnvironment || window.location.hostname === "localhost") && (
        <Box
          style={{
            fontSize: 10,
            backgroundColor: "yellow",
            position: "absolute",
            bottom: 0,
            right: 0,
            zIndex: 9999,
            padding: 2,
          }}
        >
          {path}
        </Box>
      )}
      <Doc />
    </>
  );
};
